import { ApiCaller } from '../../utils/api'
import { URLS } from '../../utils/url'
import { Message } from 'element-ui'
import axios from "axios";
import Cookies from "js-cookie";

const token = Cookies.get('current_owner_token')
const state = {
  newClinicCoupon: {
    clinic: undefined,
    id: '',
    clinic_customer_note: '',
    customer_full_name: '',
    number_uses: undefined,
    purchase_date: '',
    price: undefined,
    duration: undefined,
    menu_coupon_name: '',
    total_uses: undefined,
    treatment_nearest_date: '',
    time_limit_flag: false,
    expiry_date: '',
    menu_coupon_id: '',
    tax_included: true,
    tax_percent: 10,
    therapist_ids: []
  },
  queryClinicCoupon: {
    query: '',
    isValid: true,
    filter: []
  },
  isVisibleCsv: true,
  isValid: true,
  clinicCouponRules: {
    clinic: [
      { required: true, message: '店舗を選択してください。', trigger: 'blur' },
    ],
    menu_coupon_id: [
      { required: true, message: '回数券名を選択してください', trigger: 'blur' },
    ],
    purchase_date: [
      { required: true, message: '購入日を入力してください', trigger: 'blur' },
    ],
    expiry_date: [
      { required: true, message: '有効期限を入力してください', trigger: 'blur' },
    ],
    total_uses: [
      { required: true, message: '提供回数を入力してください', trigger: 'blur' },
    ],
    price: [
      { required: true, message: '提供価格を入力してください', trigger: 'blur' },
    ],
    input_price: [
      { required: true, message: '提供価格を入力してください', trigger: 'blur' },
    ],
    clinic_customer_note: [
      { required: true, message: '名前を入力してください', trigger: 'blur' },
    ],
    number_uses: [
      { required: true, message: ' 提供回数を入力してください', trigger: 'blur' },
    ],
    duration: [
      { required: true, message: ' 提供時間を入力してください', trigger: 'blur' },
    ]
  },
  clinicCouponVisible: false,
  clinicCouponIsEdit: false,
  clinicCoupons: [],
  clinicCoupon: {},
  editClinicCoupon: Object.assign({}, { time_limit_flag: false, expiry_date: undefined }, {}),
  therapistsModalVisible: false,
  therapistsToSort: [],
  csvVisible: false,
  clinicCouponIsEditPosition: undefined,
}

const mutations = {
  SET_EXPIRY_DATE_RULE(state, payload) {
    state.clinicCouponRules.expiry_date[0].required = payload
  },
  SET_CLINIC_COUPONS(state, clinicCoupons) {
    clinicCoupons.forEach((clinicCoupon) => {
      let therapistsToShow = clinicCoupon.therapists
      const therapistsLength = clinicCoupon.therapists.length

      if (therapistsLength > 2) {
        therapistsToShow = clinicCoupon.therapists.slice(0, 2)
        therapistsToShow.push({ name: `....他${therapistsLength - 2}名` })
      }

      clinicCoupon.therapistsToShow = therapistsToShow
    })

    state.clinicCoupons = clinicCoupons
  },
  SET_CLINIC_COUPON(state, clinicCoupon) {
    let therapistsToShow = clinicCoupon.therapists
    const therapistsLength = clinicCoupon.therapists.length

    if (therapistsLength > 2) {
      therapistsToShow = clinicCoupon.therapists.slice(0, 2)
      therapistsToShow.push({ name: `....他${therapistsLength - 2}名` })
    }

    clinicCoupon.therapistsToShow = therapistsToShow
    state.clinicCoupon = clinicCoupon
  },
  SET_CHANGE_TO_CLINIC_COUPONS(state, payload) {
    let index = state.clinicCoupons.findIndex((coupon) => coupon.id === payload.id);
    if (index != -1) {
      // do not change to "state.clinicCoupons[index] = payload", it related to Vue's reactivity system
      const updatedClinicCoupons = [...state.clinicCoupons];
      updatedClinicCoupons[index] = payload;
      state.clinicCoupons = updatedClinicCoupons;
    }
  },
  SET_CLINIC_COUPON_VISIBLE(state, payload) {
    state.clinicCouponVisible = payload
  },
  SET_IS_VISIBLE_CSV(state, payload) {
    state.isVisibleCsv = payload
  },
  SET_QUERY_CLINIC_COUPON(state, payload) {
    state.queryClinicCoupon = payload
  },
  SET_EDIT_CLINIC_COUPON(state, editClinicCoupon) {
    state.editClinicCoupon = JSON.parse(JSON.stringify(editClinicCoupon))
  },
  SET_CLINIC_COUPON_IS_EDIT(state, payload) {
    state.clinicCouponIsEdit = payload
  },
  SET_IS_VALID(state, payload) {
    state.queryClinicCoupon.isValid = payload
  },
  SET_THERAPISTS_MODAL_VISIBLE(state, payload) {
    state.therapistsModalVisible = payload
  },
  SET_THERAPISTS_TO_SORT(state, therapists) {
    state.therapistsToSort = therapists
  },
  SET_CSV_VISIBLE(state, payload) {
    state.csvVisible = payload
  },
  SET_CLINIC_COUPON_IS_EDIT_POSITION(state, payload) {
    state.clinicCouponIsEditPosition = payload
  },
}
const actions = {
  async fetchClinicCoupons({ state, commit, rootState }) {
    const response = await ApiCaller().get(URLS.CLINIC_COUPONS(), {
      params: Object.assign({}, rootState.page, { name: state.queryClinicCoupon.name, therapist: state.queryClinicCoupon.therapist, isValid: state.queryClinicCoupon.isValid, clinic_id: state.queryClinicCoupon.clinic_id })
    })
    if (response) {
      if (response.status === 200) {
        commit('SET_CLINIC_COUPONS', response.data.data)
        commit('SET_IS_VISIBLE_CSV', response.data.is_visible_csv)
        commit('page/SET_TOTAL', response.data.total, { root: true })
        commit('common/SET_START_WEEEKDAY', response.data.start_weekday, { root: true })
      } else {
        Message.error({
          message: response.data.message,
          type: 'error'
        })
      }
    }
  },
  async createClinicCoupon({ commit, dispatch }, payload) {
    let clinic_id = state.editClinicCoupon.clinic ? state.editClinicCoupon.clinic.id : null
    const response = await ApiCaller().post(URLS.CLINIC_COUPONS(), {
      clinic_coupon: Object.assign({}, state.editClinicCoupon, {
        clinic_customer_note_id: state.editClinicCoupon.clinic_customer_note.id,
        clinic_id: clinic_id
      })
    })
    if (response) {
      if (response.status === 200) {
        Message.success({
          message: response.data.message,
          type: 'success'
        })
        commit('SET_CLINIC_COUPON_VISIBLE', false)
        dispatch('fetchClinicCoupons')
      } else {
        Message.error({
          message: response.data.message,
          type: 'error'
        })
      }
    }
  },
  async getClinicCoupon({ commit, dispatch }, id) {
    const response = await ApiCaller().get(URLS.CLINIC_COUPON(id))
    if (response) {
      commit('SET_CLINIC_COUPON', response.data.data)
      commit('SET_CHANGE_TO_CLINIC_COUPONS', response.data.data)
      commit('common/SET_START_WEEEKDAY', response.data.data.start_weekday, { root: true })
    }
  },
  async updateClinicCoupon({ commit, dispatch }, payload) {
    const response = await ApiCaller().put(URLS.CLINIC_COUPON(payload.id), {
      clinic_coupon: Object.assign({}, state.editClinicCoupon, {
        clinic_customer_note_id: state.editClinicCoupon.clinic_customer_note.id
      })
    })
    if (response) {
      if (response.status === 200) {
        Message.success({
          message: response.data.message
        })
        commit('SET_CLINIC_COUPON_VISIBLE', false)
        dispatch('fetchClinicCoupons')
      } else {
        Message.error({
          message: response.data.message
        })
      }
    }
  },
  async removeClinicCoupon({ state, dispatch, commit }, id) {
    const response = await ApiCaller().delete(URLS.CLINIC_COUPON(id))

    if (response.status == 200) {
      Message.success({
        message: response.data.message,
        type: 'success'
      })
      commit('SET_CLINIC_COUPON_VISIBLE', false)
      dispatch('fetchClinicCoupons')
    } else {
      Message.error({
        message: response.data.message
      })
    }
  },
  async updateTherapistsPosition({ state, dispatch, commit }) {
    const response = await ApiCaller().put(URLS.UPDATE_CLINIC_COUPON_THERAPIST(), {
      clinic_coupon_therapist_ids: state.therapistsToSort.map(t => t.clinic_coupon_therapist_id),
      id: state.clinicCouponIsEditPosition,
    })

    if (response.status === 200) {
      Message.success({
        message: '登録しました。',
        type: 'success'
      })
      commit('SET_THERAPISTS_MODAL_VISIBLE', false)
      dispatch('fetchClinicCoupons')
    } else {
      Message.error({
        message: response.data.message
      })
    }
  },

  async importCsvCoupon({ commit, dispatch }, payload) {
    let formData = new FormData()
    formData.append('file', payload)
    const token = Cookies.get('current_owner_token')
    axios.post( '/api/v1/owner/clinic_coupons/import_csv',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`,
        }
      }
    )
    .then(function(response){
      Message.success({
        message: response.data.message,
        type: 'success'
      })
      commit('SET_CSV_VISIBLE', false)
      dispatch('fetchClinicCoupons')
    })
    .catch(function(error){
      Message.error({
        message: error.response.data.message,
      })
    });
  }
}

export default {
  namespaced: true,
  state, mutations, actions
}
